"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryError = void 0;
var shared_1 = require("@cian/peperrors/shared");
var TelemetryError = /** @class */ (function (_super) {
    __extends(TelemetryError, _super);
    function TelemetryError(_a) {
        var message = _a.message, domain = _a.domain, details = _a.details;
        var _this = _super.call(this, {
            type: 'TelemetryError',
            message: message,
            domain: domain,
            details: details,
        }) || this;
        Object.setPrototypeOf(_this, TelemetryError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, TelemetryError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return TelemetryError;
}(shared_1.GenericError));
exports.TelemetryError = TelemetryError;
//# sourceMappingURL=errors.js.map